module.exports = __webpack_public_path__ + "img/continue_btn.72e13a9b.png";